import React, { useState, useEffect } from 'react'
import './Timer.css'

const Timer = ({ timeRemaining, onTimeUp }) => {
  const [timeLeft, setTimeLeft] = useState(timeRemaining)
  const [isWarning, setIsWarning] = useState(false)

  useEffect(() => {
    setTimeLeft(timeRemaining)
  }, [timeRemaining])

  useEffect(() => {
    if (timeLeft <= 0) {
      onTimeUp()
      return
    }

    const timer = setTimeout(() => {
      setTimeLeft(prev => prev - 1)
    }, 1000)

    return () => clearTimeout(timer)
  }, [timeLeft, onTimeUp])

  useEffect(() => {
    // Show warning when 5 minutes or less remaining
    setIsWarning(timeLeft <= 300)
  }, [timeLeft])

  const formatTime = (seconds) => {
    const hours = Math.floor(seconds / 3600)
    const minutes = Math.floor((seconds % 3600) / 60)
    const secs = seconds % 60

    if (hours > 0) {
      return `${hours}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
    }
    return `${minutes}:${secs.toString().padStart(2, '0')}`
  }

  const getProgressPercentage = () => {
    return ((timeRemaining - timeLeft) / timeRemaining) * 100
  }

  return (
    <div className={`timer-container ${isWarning ? 'warning' : ''}`}>
      <div className="timer-display">
        <div className="timer-icon">⏰</div>
        <div className="timer-text">{formatTime(timeLeft)}</div>
      </div>
      
      <div className="timer-progress">
        <div 
          className="timer-progress-bar"
          style={{ width: `${getProgressPercentage()}%` }}
        />
      </div>
      
      {isWarning && (
        <div className="timer-warning">
          ⚠️ Time running out!
        </div>
      )}
    </div>
  )
}

export default Timer
